import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * The last few pathnames this tab visited, oldest first, for the crash report
 * RootErrorBoundary files. A module-level array rather than state, so recording
 * a route re-renders nothing.
 */
const LIMIT = 10;
const visited: string[] = [];

export function recordRoute(path: string): void {
  if (visited[visited.length - 1] === path) return;
  visited.push(path);
  if (visited.length > LIMIT) visited.splice(0, visited.length - LIMIT);
}

export function recentRoutes(): string[] {
  return [...visited];
}

/**
 * Renders nothing. Must sit inside the app's own `<Router>`: App.js mounts a
 * second BrowserRouter inside index.js's, and each owns its history, so a
 * listener on the outer one never hears the app's navigation.
 */
export default function RecentRoutes(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    recordRoute(pathname);
  }, [pathname]);
  return null;
}
